import LargeWinList from './large-win.list';

export default {
  list: LargeWinList,
};
